export const FREE_SHIPPING_THRESHOLD = 500

export const initialForm = {
  name: '',
  email: '',
  phone: '',
  address: '',
  city: '',
  province: '',
  postalCode: '',
}
